import { render, staticRenderFns } from "./CancelVerificationModal.vue?vue&type=template&id=753236fe&scoped=true&"
import script from "./CancelVerificationModal.vue?vue&type=script&lang=js&"
export * from "./CancelVerificationModal.vue?vue&type=script&lang=js&"
import style0 from "./CancelVerificationModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CancelVerificationModal.vue?vue&type=style&index=1&id=753236fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753236fe",
  null
  
)

export default component.exports